/**
 * @generated SignedSource<<0b685ebcda3815024a300b336105c2db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DataHealthKind = "EXTERNAL" | "SCHEDULER" | "SILENCE" | "SOURCE" | "TABLE" | "%future added value";
export type DataHealthStatus = "AMBER" | "GREEN" | "RED" | "%future added value";
export type dataHealthQuery$variables = Record<PropertyKey, never>;
export type dataHealthQuery$data = {
  readonly dataHealth: {
    readonly counts: {
      readonly amber: number;
      readonly frozen: number;
      readonly green: number;
      readonly red: number;
      readonly total: number;
    };
    readonly domains: ReadonlyArray<string>;
    readonly dueDrops: ReadonlyArray<{
      readonly attention: ReadonlyArray<string>;
      readonly attentionDetail: string | null | undefined;
      readonly domain: string;
      readonly durationSeconds: number | null | undefined;
      readonly expiresOn: any | null | undefined;
      readonly frozen: boolean;
      readonly kind: DataHealthKind;
      readonly lastSuccessAt: any | null | undefined;
      readonly name: string;
      readonly nextDueAt: any | null | undefined;
      readonly publisherLatest: string | null | undefined;
      readonly status: DataHealthStatus;
      readonly versionHeld: string | null | undefined;
      readonly writtenAt: any;
    }>;
    readonly expiring: ReadonlyArray<{
      readonly daysLeft: number;
      readonly domain: string;
      readonly expired: boolean;
      readonly expiresOn: any;
      readonly name: string;
    }>;
    readonly generatedAt: any;
    readonly lastWrittenAt: any | null | undefined;
    readonly liveTier: string | null | undefined;
    readonly nextExpiry: {
      readonly daysLeft: number;
      readonly domain: string;
      readonly expired: boolean;
      readonly expiresOn: any;
      readonly name: string;
    } | null | undefined;
    readonly rows: ReadonlyArray<{
      readonly attention: ReadonlyArray<string>;
      readonly attentionDetail: string | null | undefined;
      readonly domain: string;
      readonly durationSeconds: number | null | undefined;
      readonly expiresOn: any | null | undefined;
      readonly frozen: boolean;
      readonly kind: DataHealthKind;
      readonly lastOutcome: string | null | undefined;
      readonly lastSuccessAt: any | null | undefined;
      readonly name: string;
      readonly nextDueAt: any | null | undefined;
      readonly publisherLatest: string | null | undefined;
      readonly publisherLatestAt: any | null | undefined;
      readonly status: DataHealthStatus;
      readonly versionHeld: string | null | undefined;
      readonly writtenAt: any;
    }>;
    readonly scheduler: {
      readonly attention: ReadonlyArray<string>;
      readonly attentionDetail: string | null | undefined;
      readonly domain: string;
      readonly durationSeconds: number | null | undefined;
      readonly expiresOn: any | null | undefined;
      readonly frozen: boolean;
      readonly kind: DataHealthKind;
      readonly lastOutcome: string | null | undefined;
      readonly lastSuccessAt: any | null | undefined;
      readonly name: string;
      readonly nextDueAt: any | null | undefined;
      readonly publisherLatest: string | null | undefined;
      readonly status: DataHealthStatus;
      readonly versionHeld: string | null | undefined;
      readonly writtenAt: any;
    } | null | undefined;
  };
};
export type dataHealthQuery = {
  response: dataHealthQuery$data;
  variables: dataHealthQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frozen",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domain",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attention",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attentionDetail",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionHeld",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publisherLatest",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSuccessAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastOutcome",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextDueAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresOn",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "writtenAt",
  "storageKey": null
},
v15 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "daysLeft",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "expired",
    "storageKey": null
  }
],
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DataHealthReport",
    "kind": "LinkedField",
    "name": "dataHealth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "generatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastWrittenAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "liveTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthCounts",
        "kind": "LinkedField",
        "name": "counts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "red",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "green",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "domains",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthRow",
        "kind": "LinkedField",
        "name": "scheduler",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v0/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthRow",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v0/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publisherLatestAt",
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthRow",
        "kind": "LinkedField",
        "name": "dueDrops",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v0/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthExpiry",
        "kind": "LinkedField",
        "name": "expiring",
        "plural": true,
        "selections": (v15/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DataHealthExpiry",
        "kind": "LinkedField",
        "name": "nextExpiry",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHealthQuery",
    "selections": (v16/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "dataHealthQuery",
    "selections": (v16/*: any*/)
  },
  "params": {
    "cacheID": "5c653f7e1a663f376da3639c564b3b74",
    "id": null,
    "metadata": {},
    "name": "dataHealthQuery",
    "operationKind": "query",
    "text": "query dataHealthQuery {\n  dataHealth {\n    generatedAt\n    lastWrittenAt\n    liveTier\n    counts {\n      red\n      amber\n      green\n      frozen\n      total\n    }\n    domains\n    scheduler {\n      kind\n      name\n      domain\n      status\n      frozen\n      attention\n      attentionDetail\n      versionHeld\n      publisherLatest\n      lastSuccessAt\n      lastOutcome\n      nextDueAt\n      durationSeconds\n      expiresOn\n      writtenAt\n    }\n    rows {\n      kind\n      name\n      domain\n      status\n      frozen\n      attention\n      attentionDetail\n      versionHeld\n      publisherLatest\n      publisherLatestAt\n      lastSuccessAt\n      lastOutcome\n      nextDueAt\n      durationSeconds\n      expiresOn\n      writtenAt\n    }\n    dueDrops {\n      kind\n      name\n      domain\n      status\n      frozen\n      attention\n      attentionDetail\n      versionHeld\n      publisherLatest\n      lastSuccessAt\n      nextDueAt\n      durationSeconds\n      expiresOn\n      writtenAt\n    }\n    expiring {\n      name\n      domain\n      expiresOn\n      daysLeft\n      expired\n    }\n    nextExpiry {\n      name\n      domain\n      expiresOn\n      daysLeft\n      expired\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5085475728b6909ec1fb0e030c622a3c";

export default node;
